import "./index.less";



// WEBPACK FOOTER //
// ./ecology9/wea-video/style/index.js